module.exports = __webpack_public_path__ + "static/media/main_visual_construction_telehandler_mht_10135_manitou.a9a7c708.png";